import { useToken } from "@dexteel/mesf-core";
import { useMemo } from "react";
import { EditWorkOrderModal } from "@/shared/work-orders-modals/components/modal-edit-work-order";
import { INITIAL_VALUES_MODAL } from "@/shared/work-orders-modals/models/ModalInitialValue";
import type { ModalWorkOrder } from "@/shared/work-orders-modals/models/ModalWorkOrder";
import { CreateTemplate } from "@/pages/templates/components/CreateTemplate";
import { TemplatesProvider } from "@/pages/templates/context/templatesContext";

type Props = {
	// Asset the dialog is opened for; null keeps it closed
	assetId: number | null;
	onClose: (created: boolean) => void;
};

// Both stay mounted while closed so their success snackbar outlives the dialog
export const MapCreateWorkOrder = ({ assetId, onClose }: Props) => {
	const { getUserName } = useToken();
	const userName = getUserName();

	const newWorkOrder = useMemo<ModalWorkOrder | null>(
		() =>
			assetId === null
				? null
				: {
						...INITIAL_VALUES_MODAL,
						AssetId: assetId,
						Title: "",
						TypeCode: "RM",
						WorkOrderStatusCode: "O",
						CraftId: 1,
						WorkOrderOpenedBy: userName,
						OpenTimestamp: new Date(),
					},
		[assetId, userName],
	);

	return (
		<EditWorkOrderModal
			show={newWorkOrder !== null}
			data={newWorkOrder}
			initialNewMode
			onHide={onClose}
		/>
	);
};

// CreateTemplate reads the Templates page context, so it gets its own provider here
export const MapCreateTemplate = ({ assetId, onClose }: Props) => (
	<TemplatesProvider>
		<CreateTemplate
			show={assetId !== null}
			initialAssetId={assetId}
			onHide={onClose}
		/>
	</TemplatesProvider>
);
